/** @format */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SkeletonShape } from '../../../models/skeleton-loader.interface';

@Component({
    selector: 'product-reviews-skeleton',
    templateUrl: './skeleton.component.html',
    styleUrls: ['./skeleton.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SkeletonComponent {
	@Input() skeletonShape: SkeletonShape;
	@Input() skeletonCount: number;
}
